import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatSidenav } from '@angular/material/sidenav';
import { Router } from '@angular/router';
import { OktaAuthStateService } from '@okta/okta-angular';
import { Subject, combineLatest } from 'rxjs';
import { ContractGuard } from 'src/app/core/guards/contract.guard';
import { filter, takeUntil } from 'rxjs/operators';
import { PGHOktaService } from 'src/app/core/services/pghokta.service';
import { ISelectedContract, LoggedInUserSettings } from 'src/app/core/services/settings/logged-in-user-settings';
import { myAccountRouteWithSlash, myTechServicesRouteWithSlash } from '../../../../route-constants';
import { CLAIMSANDSUPPORTURL, CLAIMSSUPPORTURLNAME, COVERAGEURLNAME, PROFILEURLNAME, VIEWCLAIMSTATUS, VIEWTUTORIALS } from '../../../constants/feature-key.constants';
import { NavLists } from '../sidenav.component';
import { GSSPAuthenticationService } from 'src/app/core/services/gssp-authentication.service';
import { PghUserDeviceBase } from 'src/app/shared/device/pgh-user-device';
import { DomSanitizer } from '@angular/platform-browser';
import { SecurityContext } from '@angular/core';
import { SelectedDeviceService } from 'src/app/shared/device/selected-device.service';
import { ClaimsNoDevicesModalWindowComponent } from 'src/app/shared/components/claims-no-devices-modal-window/claims-no-devices-modal-window.component';
import { ADPResourceService, SitefinityMenuItem } from 'digital-core';
import { GlobalModalWindowService } from 'src/app/core/services/global-modal-window.service';
import { PGHAppLoadService } from 'src/app/core/services/pgh-app-load.service';
import { StorageService } from 'src/app/core/services/storage.service';
import { GetStartedModalComponent } from 'src/app/shared/components/get-started-modal/get-started-modal.component';

@Component({
    selector: 'app-logged-in-navlist',
    templateUrl: './logged-in-navlist.component.html',
    styleUrls: ['./logged-in-navlist.component.scss']
})
export class LoggedInNavlistComponent implements OnInit, OnChanges, OnDestroy {
    readonly OKTA_TOKEN_STORAGE = 'okta-token-storage';
    @Input() isShowing: boolean;
    @Input() sidenavRef: MatSidenav;

    NavLists = NavLists;
    isAuthenticated: boolean = false;
    currentNavList: number = NavLists.root;
    userGivenName: string = '';
    headerLoggedInSettings: SitefinityMenuItem[] = null;
    tempHeaderSettings: SitefinityMenuItem[] = null;
    defaultProfileLinks: SitefinityMenuItem[];
    filteredProfileLinks: SitefinityMenuItem[];
    defaultClaimsLinks: SitefinityMenuItem[];
    defaultCoverageLinks: SitefinityMenuItem[];
    defaultCoverageLinksLoaded: boolean = false;
    profileLinksLoaded: boolean = false;
    isCancelled: boolean;
    cancelledOrExpiredHasFullAccess: boolean = false;
    isExpired: boolean;
    isPrimary: boolean = false;
    isPTPO: boolean = false;
    hasActiveAccount: boolean = true;
    userAvatarUrl: string = '';
    userAvatarColor: string = '';
    fullName: string = '';
    allDevices: PghUserDeviceBase[];
    isGSSP = false;
    dealerCode: string;
    masterCertificateNumber: string;
    coverageTypeCode: string;
    redirectUrl: string;
    contractNum: string;
    zipCode: string;
    isActive: boolean;
    childCertificateNumber: string;
    isSRLoaded = false;
    languages: any;
    selectedLanguageKey: string = null;
    chooseLanguage: string = null;
    chooseLanguageTitle: string = null;

    private destroy$ = new Subject<boolean>();

    constructor(
        private oktaAuth: OktaAuthStateService,
        private selectedDeviceService: SelectedDeviceService,
        private appLoadService: PGHAppLoadService,
        private loggedInUserSettings: LoggedInUserSettings,
        public matDialog: MatDialog,
        private contractGuard: ContractGuard,
        private router: Router,
        private domSanitizer: DomSanitizer,
        private gsspAuthService: GSSPAuthenticationService,
        private pghOktaService: PGHOktaService,
        private resourceService: ADPResourceService,
        private storageService: StorageService,
        private globalModalWindowService: GlobalModalWindowService
    ) { }

    async ngOnInit(): Promise<void> {
        let userClaims = null;
        this.isAuthenticated = this.pghOktaService.isTokenValid();

       this.oktaAuth.authState$
            .pipe(takeUntil(this.destroy$))
            .subscribe(async (authState) => {
                this.isAuthenticated = authState.isAuthenticated;
                if (this.isAuthenticated) {
                    userClaims = await this.pghOktaService.getUser();
                    this.userGivenName = userClaims.given_name;
                    if (this.userGivenName) {
                        this.userGivenName = this.userGivenName[0].toUpperCase() + this.userGivenName.substr(1).toLowerCase();
                    }
                }
            });
        if (this.isAuthenticated) {
            userClaims = await this.pghOktaService.getUser();
            this.userGivenName = userClaims.given_name;
            if (this.userGivenName) {
                this.userGivenName = this.userGivenName[0].toUpperCase() + this.userGivenName.substr(1).toLowerCase();
            }
        }
       this.oktaAuth.authState$.pipe(takeUntil(this.destroy$)).subscribe(authState => this.isAuthenticated = authState.isAuthenticated);
       this.appLoadService.isSiteResourcesLoaded.subscribe(value => {
            this.isSRLoaded = value;
            if (value) {
                this.getLanguages();
                this.setAppHeaders();
            }
        });
        this.loggedInUserSettings.$selectedContract
            .pipe(takeUntil(this.destroy$))
            .subscribe((contract) => {
                if (contract) {
                    this.isExpired = contract.isExpired;
                    this.isCancelled = contract.isCancelled;
                    this.isPrimary = contract.isPrimary;
                    this.isPTPO = contract.isPTPO;
                    if (userClaims) {
                        const isEprismOnly = this.storageService.getLocal<string>(`IsEprismOnly`);
                        const loggedInMember = isEprismOnly == 'true' ?  contract?.members[0]
                            : contract?.members?.find(m => m?.emailAddress?.toLowerCase() === userClaims?.email?.toLowerCase());
                        if (loggedInMember) {
                            this.fullName = loggedInMember.firstName + ' ' + loggedInMember.lastName;
                            this.userAvatarUrl = loggedInMember.avatarUrl;
                            this.userAvatarColor = loggedInMember.profileColor;
                        }
                    }
                }
            });
        this.loggedInUserSettings.$hasActiveAccount
            .pipe(takeUntil(this.destroy$))
            .subscribe((hasActiveAccount) => {
                this.hasActiveAccount = hasActiveAccount;
            });
    }

    private setAppHeaders() {
        this.cancelledOrExpiredHasFullAccess = this.resourceService.isPortalSettingTrue('Global_CancelledOrExpiredContract_HasFullAccess');
        this.resourceService.getPortalMenus('Header_LoggedIn_Nav_Menu').subscribe(data => {
            this.headerLoggedInSettings = data.MenuItems;
            if (!this.tempHeaderSettings) {
                this.tempHeaderSettings = JSON.parse(JSON.stringify(data.MenuItems));
            }

        });
        this.loggedInUserSettings.$selectedContract.subscribe(contract => {
            if (this.tempHeaderSettings?.length) {
                this.headerLoggedInSettings = JSON.parse(JSON.stringify(this.tempHeaderSettings));
                if (!contract?.isPrimary) {
                    this.headerLoggedInSettings = this.headerLoggedInSettings?.filter(x => x.LinkUrl !== '/claims');
                    this.headerLoggedInSettings = this.headerLoggedInSettings?.filter(x => x.LinkUrl !== '/file-a-claim');
                }
            }

            if (this.headerLoggedInSettings?.length) {
                const profileLinks = this.headerLoggedInSettings.find(x => x.LinkUrl === PROFILEURLNAME);
                if (profileLinks) {
                    this.resourceService.getPortalMenus('Header_Profile_Child_Menu').subscribe(childData => {
                        this.defaultProfileLinks = childData.MenuItems;

                        let hasP360MobilePolicy = this.storageService.getLocal<string>(`EprismContractsCount`) > '0';
                        let hasP360HomeTechPolicy = this.storageService.getLocal<string>(`ElitaContractsCount`) > '0';

                        this.filteredProfileLinks = (hasP360MobilePolicy && !hasP360HomeTechPolicy) || !this.isPrimary ?
                        this.defaultProfileLinks.filter(x => !x.LinkUrl.includes('communication-preferences') && !x.LinkUrl.includes('family-management')) : this.defaultProfileLinks;

                        /*this.defaultProfileLinks = (hasP360MobilePolicy && !hasP360HomeTechPolicy && !contract?.isPrimary) ?
                        this.defaultProfileLinks.filter(x => !x.LinkUrl.includes('details')) :
                        this.defaultProfileLinks;*/

                        this.profileLinksLoaded = true;
                    });
                }
                const supportCenter = this.headerLoggedInSettings.find(x => x.LinkUrl.endsWith(CLAIMSSUPPORTURLNAME));
                if (supportCenter) {
                    this.resourceService.getPortalMenus('Header_Claims_Support_Child_Menu').subscribe(childData => {
                        let hasP360MobilePolicy = this.storageService.getLocal<string>(`EprismContractsCount`) > '0';
                        let hasP360HomeTechPolicy = this.storageService.getLocal<string>(`ElitaContractsCount`) > '0';
                        this.defaultClaimsLinks = childData.MenuItems;
                        this.defaultClaimsLinks = (hasP360MobilePolicy && !hasP360HomeTechPolicy) ?
                        this.defaultClaimsLinks.filter(x => !x.LinkUrl.includes('/faq')) :
                        this.defaultClaimsLinks;
                        this.defaultClaimsLinks = (!hasP360MobilePolicy && hasP360HomeTechPolicy) ?
                            this.defaultClaimsLinks.filter(x => !x.LinkUrl.includes('/p360')) :
                            this.defaultClaimsLinks;
                    });
                }
                const coverageLinks = this.headerLoggedInSettings.find(x => x.LinkUrl.endsWith(COVERAGEURLNAME));
                if (coverageLinks) {
                    this.resourceService.getPortalMenus('Header_Coverage_Child_Menu').subscribe(childData => {
                        let hasP360MobilePolicy = this.storageService.getLocal<string>(`EprismContractsCount`) > '0';
                        let hasP360HomeTechPolicy = this.storageService.getLocal<string>(`ElitaContractsCount`) > '0';
                        let filteredChildMenuItems = childData.MenuItems;

                        if (hasP360MobilePolicy && hasP360HomeTechPolicy) {
                            // Multipe policy both P360 Mobile & Home tech
                            filteredChildMenuItems = childData.MenuItems;
                        } else if (hasP360HomeTechPolicy) {
                            filteredChildMenuItems = childData.MenuItems.filter(x => x.LinkUrl.endsWith('home'));
                        } else if (hasP360MobilePolicy) {
                            filteredChildMenuItems = childData.MenuItems.filter(x => x.LinkUrl.endsWith('mobile'));
                        }

                        this.defaultCoverageLinks = filteredChildMenuItems;
                        this.defaultCoverageLinksLoaded = true;
                    });
                }
            }
        });
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.isShowing && changes.isShowing.currentValue === false) {
            this.currentNavList = NavLists.root;
        }
    }

    ngOnDestroy() {
        this.destroy$.next(true);
    }

    checkRouteAvailability(route: string) {
        if (((this.isCancelled || this.isExpired) && !this.cancelledOrExpiredHasFullAccess) && route === myAccountRouteWithSlash) {
            return false;
        } else if ((((this.isCancelled || this.isExpired) && !this.cancelledOrExpiredHasFullAccess) || this.isPTPO) && route === myTechServicesRouteWithSlash) {
            return false;
        } else {
            return true;
        }
    }

    profileButtonClick(navigationItem: SitefinityMenuItem) {
        let url = navigationItem.LinkUrl;
        url = url.trim();
        if (url.startsWith('/')) {
            this.router.navigate([url]);
            this.sidenavRef.close();
        }
    }

    coverageButtonClick(navigationItem: SitefinityMenuItem) {
        let url = navigationItem.LinkUrl;
        url = url.trim();
        if (url.startsWith('/')) {
            this.router.navigate([url]);
            this.sidenavRef.close();
        }
    }

    openTutorial(label: string) {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.disableClose = false;
      dialogConfig.ariaLabel = label;
      dialogConfig.id = 'get-started-dialog';
      dialogConfig.height = 'auto';
      dialogConfig.data = {
        title: 'Account',
        content: '',
        buttonText: 'Next'
      };

      this.matDialog.open(GetStartedModalComponent, dialogConfig);
    }

    claimsButtonClick(navigationItem: SitefinityMenuItem) {
        if (navigationItem?.LinkUrl === VIEWCLAIMSTATUS) {
            this.viewClaimHistoryAndStatus();
            return;
        }

        if (navigationItem?.LinkUrl == VIEWTUTORIALS) {
            this.openTutorial(this.resourceService.getLabel('Perks_Tutorial_Button_Button'));
            return;
        }

        //special behavior for claims & support navigation link to only allow navigation to Claims & Support page if user
        //has devices in their inventory
        if (navigationItem?.LinkUrl === CLAIMSANDSUPPORTURL) {
            if (this.resourceService.getViewLabel('Global_Modal_NoDevices_Title')) {
                this.allDevices = this.selectedDeviceService.getAllDevices();
                if(this.allDevices.length > 0) {
                    this.router.navigate([navigationItem.LinkUrl]);
                    this.sidenavRef.close();
                }
                //display a modal notification to user that they have no devices in their inventory with an option to navigate to My Devices page
                else {
                    this.displayClaimsNoDevicesModal();
                    this.sidenavRef.close();
                }
            } else {
                this.router.navigate([navigationItem.LinkUrl]);
                this.sidenavRef.close();
            }
        } else {
            // open external links like FAQs in new window
            if (navigationItem?.LinkUrl.startsWith('http')) {
                window.open(navigationItem?.LinkUrl, '_blank');
            } else {
                this.router.navigate([navigationItem?.LinkUrl]);
            }
            this.sidenavRef.close();
        }
    }

    displayClaimsNoDevicesModal(msg: string = '') {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.ariaLabel = this.resourceService.getPortalLabel("Global_Modal_NoDevices_Title").Value;
        dialogConfig.disableClose = false;
        dialogConfig.id = 'claims-no-devices-dialog';
        dialogConfig.height = 'auto';
        dialogConfig.data = {
            subtitle: "Global_Modal_NoDevices_Subtitle",
            title: "Global_Modal_NoDevices_Title",
            description: "Global_Modal_NoDevices_Description",
            buttonText: "Global_Modal_NoDevices_ButtonText"
        };

        const dialogRef = this.matDialog.open(ClaimsNoDevicesModalWindowComponent, dialogConfig);

        dialogRef.afterClosed().subscribe(res => {
            if (res.data && res.data.result === 'success') {
                this.router.navigate([this.resourceService.getPortalSetting("URL_MyDevices").Value]);
            }
        });
    }

    viewClaimHistoryAndStatus() {
        const searchClaimsUrl = this.resourceService.getPortalSetting("URL_ClaimsPortal").Value;;

        const joined$ = combineLatest([
            this.loggedInUserSettings.$selectedContract
        ]).pipe(
            filter(([a]) => a !== null),
            takeUntil(this.destroy$)
        );

        joined$.subscribe(([selectedContract]:
            [ISelectedContract]) => {
            this.isActive = this.contractGuard.activateGuard(selectedContract, false);
            this.isGSSP = selectedContract.useGSSPClaims;
            this.masterCertificateNumber = selectedContract?.id;
            this.childCertificateNumber = selectedContract?.certificateNumberForGadgetsPolicy;
            this.dealerCode = selectedContract.dealerId;
            this.coverageTypeCode = 'AD';
            this.zipCode = selectedContract?.zipCode;
            this.contractNum = selectedContract && selectedContract?.members && selectedContract?.members.length ? selectedContract?.members[0].contractNumber : '';
        });

        if (this.isGSSP) {
            if (this.masterCertificateNumber && this.masterCertificateNumber.length > 0) {
                const childCertificateNumbers: [string] = [this.childCertificateNumber];
                this.gsspAuthService.postGenerateGSSPToken(this.dealerCode, this.masterCertificateNumber, childCertificateNumbers, null).subscribe({
                    next: (gsspAuthToken: any) => {
                        if (gsspAuthToken && gsspAuthToken.length > 0) {
                            this.redirectUrl = `${searchClaimsUrl}?accessToken=${gsspAuthToken}`;
                            this.redirectUrl = this.domSanitizer.sanitize(SecurityContext.URL, this.redirectUrl);
                            window.open(this.redirectUrl, '_self');
                        } else {
                            this.globalModalWindowService.showModalWindowMin('Global_Modal_Error_InvalidGsspAuthToken_Title', 'GetGsspAuthToken');
                        }
                    }
                });
            } else {
                this.globalModalWindowService.showModalWindowMin('Global_Modal_Error_MissingMasterCertificate_Title', 'GetGsspAuthToken');
            }
        } else {
            const tokens = JSON.parse(localStorage.getItem(this.OKTA_TOKEN_STORAGE));
            const accessToken = tokens.access_token && tokens.access_token.accessToken
                ? tokens.access_token.accessToken
                : tokens?.accessToken?.accessToken;
            const hashedQuery = btoa(`cn=${this.contractNum}&zip=${this.zipCode}`);
            if (accessToken.indexOf(' ') >= 0) {
                console.log('invalid token');
            } else {
                this.redirectUrl = `${searchClaimsUrl}?q=${hashedQuery}&token=${accessToken}`;
                this.redirectUrl = this.domSanitizer.sanitize(SecurityContext.URL, this.redirectUrl);
                window.open(this.redirectUrl, '_blank');
            }
        }
    }

    getSelectedLanguage() {
        return this.selectedLanguageKey || 'EN';
    }

    getLanguages() {
        let local = this.storageService.getLocal<string>(`language`);
        this.selectedLanguageKey = local ?? 'EN';
        let languages = this.resourceService.getListItemResource("Global_Languages");
        languages.subscribe((data) => {
            this.languages = data;
            const language = this.languages.find(x => x.Key.toLocaleLowerCase() === this.getSelectedLanguage().toLocaleLowerCase());
            this.selectedLanguageKey = language?.Key;
            this.chooseLanguage = this.languages.find(x => x.Key != this.selectedLanguageKey)?.Value;
            this.chooseLanguageTitle = this.resourceService.getViewLabel('Global_Language_Title') + this.chooseLanguage;
            if (!this.selectedLanguageKey) {
                this.storageService.setLocal(`language`, null);
                window.location.reload();
            }
        });
    }

    toggleLanguage() {
        const language = this.languages.find(x => x.Key.toLocaleLowerCase() != this.getSelectedLanguage().toLocaleLowerCase());
        this.storageService.setLocal<string>(`language`, language?.Key);
        window.location.reload();
    }
}
